import React, { useState, useReducer, useEffect } from 'react';

import { UserAddOutlined, CopyOutlined } from '@ant-design/icons';
import { Modal, Input, Button, Space, Checkbox, Spin } from 'antd';
import { toast } from 'react-toastify';

export default function CreateUserLink(
	{
		orgId,
	}: { orgId: string }
) {
	const [ open, setOpen, ] = useState<boolean>(false);
	const [ isAdmin, setIsAdmin, ] = useState<boolean>(false);
	const [ signUpLink, setSignUpLink, ] = useState<string>('');
	const [ updateToken, setUpdateToken, ] = useReducer((x) => x + 1, 0);
	const [ loading, setLoading, ] = useState<boolean>(true);

	useEffect(() => {
		setLoading(true);
		if(!orgId) return;
		
		const payload = {
			org_id: orgId,
			role: isAdmin ? 'admin' : 'user',
			expiration: Date.now() + (10 * 60 * 1000),
		};
        
		const newToken = btoa(JSON.stringify(payload));
        
		const publicUrl = process.env.REACT_APP_PUBLIC_URL || window.location.origin;
		setSignUpLink(`${publicUrl}/cadastro?token=${newToken}`);
		setLoading(false);
	}, [ isAdmin, updateToken, orgId, open, ]);

	const handleCopyLink = async () => {
		try {
			await navigator.clipboard.writeText(signUpLink);
			toast.success('Link copiado para área de transferência!', { autoClose: 2000, });
		} catch (error) {
			toast.error('Erro ao copiar link!', { autoClose: 2000, });
		}
	};

	const handleUpdateToken = () => {
		setUpdateToken();
		toast.success('Token re-gerado com sucesso!', { autoClose: 2000, });
	};

	return (
		<>
			<Button
				type="text"
				icon={<UserAddOutlined />}
				onClick={() => setOpen(true)}
			/>
			<Modal
				centered
				title={'Link de Criação de Usuário Parceiro'}
				open={open}
				onCancel={() => {
					setOpen(false);
					toast.info('Operação cancelada!', { autoClose: 1000, });
				}}
				footer={[
					<Button key="close" onClick={() => setOpen(false)}>
                        Fechar
					</Button>,
					<Button key="update" type="primary" onClick={handleUpdateToken}>
                        Atualizar
					</Button>,
				]}
				destroyOnHidden
			>
				<Space direction="vertical" size="middle" style={{ width: '100%', }}>
					<div>
						<label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', }}>
                            Link de Cadastro:
						</label>
						<div style={{ fontSize: '12px', color: '#666', }}>
                            Este link expira em 10 minutos após a geração.
						</div>
						<Spin spinning={loading}>
							<Input
								value={signUpLink}
								readOnly
								suffix={
									<Button
										type="text"
										icon={<CopyOutlined />}
										onClick={handleCopyLink}
										style={{ border: 'none', padding: '0 4px', }}
									/>
								}
							/>
						</Spin>
					</div>
				</Space>
				<Checkbox checked={isAdmin} onChange={e => setIsAdmin(e.target.checked)}>
                    Administrador
				</Checkbox>
			</Modal>
		</>
	);
}